var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPrint48Line = function SvgIconPrint48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 17.299h-1.2v-5.1c0-1.6-1.3-2.9-2.9-2.9H17.7c-1.6 0-2.9 1.3-2.9 2.9v5.1h-1.2a5.31 5.31 0 0 0-5.3 5.3v7.2c0 1.6 1.3 2.9 2.9 2.9h3.6v3.1c0 1.6 1.3 2.9 2.9 2.9h12.6c1.6 0 2.9-1.3 2.9-2.9v-3.1h3.6c1.6 0 2.9-1.3 2.9-2.9v-7.2c0-2.92-2.38-5.3-5.3-5.3Zm-16.2-4.6h11.6v4.6H18.2v-4.6Zm11.6 22.6H18.2v-6.6h11.6v6.6Zm6.5-6h-3.1v-2.3c0-.94-.76-1.7-1.7-1.7h-15c-.94 0-1.7.76-1.7 1.7v2.3h-3.1v-6.7c0-1.05.85-1.9 1.9-1.9h20.8c1.05 0 1.9.85 1.9 1.9v6.7Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.29 22.299c-.66.66-.66 1.74 0 2.4.66.66 1.74.66 2.4 0 .66-.66.66-1.74 0-2.4-.66-.66-1.74-.66-2.4 0Z",
    fill: "current"
  })));
};
export default SvgIconPrint48Line;